// @flow
/**
 * User: Mike Chung
 * Date: 11/3/2018
 * Time: 10:21 PM
 */
import React from 'react';
import './rounded-spinner.css';

type RoundedSpinnerProps = {};

export default function RoundedSpinner(props: RoundedSpinnerProps) {
    return <span className={"loading"} />;
};


// WEBPACK FOOTER //
// ./src/components/util/spinner/RoundedSpinner.js